import { permissionsService } from '@/utils/permissionChecker'; 

function applyPermissionLogic(el, binding) {
  const permission = binding.value;
  const hasPermission = permissionsService.hasPermission(permission);

  const target = el.tagName === 'BUTTON' || el.tagName === 'INPUT'
    ? el
    : el.querySelector('button, input');

  if (!hasPermission) {
    if (binding.modifiers.disable) {
      if (target) {
        target.disabled = true;
        target.classList.add('disabled');
      }
    } else if (binding.modifiers.readonly) {
      if (target) {
        target.readOnly = true;
        target.classList.add('readonly');
      }
    } else {
      el.style.display = 'none';
    }
  } else {
    if (binding.modifiers.disable) {
      if (target) {
        target.disabled = false;
        target.classList.remove('disabled');
      }
    } else if (binding.modifiers.readonly) {
      if (target) {
        target.readOnly = false;
        target.classList.remove('readonly');
      }
    } else {
      el.style.display = '';
    }
  }
}

export const canDirective = {
  beforeMount(el, binding) {
    applyPermissionLogic(el, binding);
  },
  
  updated(el, binding) {
    if (binding.value !== binding.oldValue) {
      applyPermissionLogic(el, binding);
    }
  }
};

export default {
  install(app) {
    app.directive('can', canDirective);
  }
};